import { render } from "./AdminUserNotificationList.vue?vue&type=template&id=a66a5a86&scoped=true&ts=true&lang=true"
import script from "./AdminUserNotificationList.vue?vue&type=script&lang=ts"
export * from "./AdminUserNotificationList.vue?vue&type=script&lang=ts"

import "./AdminUserNotificationList.vue?vue&type=style&index=0&id=a66a5a86&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66a5a86"]])

export default __exports__